module.exports = __webpack_public_path__ + "static/media/thumbEmoji.644c1411.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Other/thumbEmoji.png
// module id = 238
// module chunks = 0